import { render } from "./Model.vue?vue&type=template&id=1158f6c8&scoped=true"
import script from "./Model.vue?vue&type=script&lang=js"
export * from "./Model.vue?vue&type=script&lang=js"

import "./Model.vue?vue&type=style&index=0&id=1158f6c8&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1158f6c8"]])

export default __exports__